"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RouteShared = RouteShared;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _PrivateRoute = _interopRequireDefault(require("./PrivateRoute"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Shared Route to all tenants
 * @param {*} param0
 * @returns
 */
function RouteShared(props) {
  // const CommonLogin = React.lazy(() =>
  //   import(
  //     '../../../../apps/tenant' +
  //       props.tenantId +
  //       '/src/modules/commonlogin/commonlogin.module'
  //   )
  // );
  // const Passcode = React.lazy(() =>
  //   import(
  //     '../../../../apps/tenant' +
  //       props.tenantId +
  //       '/src/modules/passcode/passcode.module'
  //   )
  // );
  // const Error = React.lazy(() =>
  //   import(
  //     '../../../../apps/tenant' +
  //       props.tenantId +
  //       '/src/modules/error/error.module'
  //   )
  // );

  // const brand = props.brand === undefined ? 'primary' : props.brand;
  // const Site = React.lazy(() =>
  //   import(
  //     '../../../../apps/tenant' +
  //       props.tenantId +
  //       '/src/modules/' +
  //       brand +
  //       '/site/site.module'
  //   )
  // );
  // const Report = React.lazy(() =>
  //   import(
  //     '../../../../apps/tenant' +
  //       props.tenantId +
  //       '/src/modules/' +
  //       brand +
  //       '/report/report.module'
  //   )
  // );

  // const Contact = React.lazy(() =>
  //   import(
  //     '../../../../apps/tenant' +
  //       props.tenantId +
  //       '/src/modules/' +
  //       brand +
  //       '/contact/contact.module'
  //   )
  // );
  // // Start System Panel
  // // Invite
  // const Invite = React.lazy(() =>
  //   import(
  //     '../../../../apps/tenant' +
  //       props.tenantId +
  //       '/src/modules/' +
  //       brand +
  //       '/pallete2022/ContentPanels/invite.module'
  //   )
  // );
  // //Invite
  // // Profile
  // const Profile = React.lazy(() =>
  //   import(
  //     '../../../../apps/tenant' +
  //       props.tenantId +
  //       '/src/modules/' +
  //       brand +
  //       '/pallete2022/ContentPanels/profile.module'
  //   )
  // );
  // //Profile
  // // Featured_Video
  // const FeaturedVideo = React.lazy(() =>
  //   import(
  //     '../../../../apps/tenant' +
  //       props.tenantId +
  //       '/src/modules/' +
  //       brand +
  //       '/pallete2022/ContentPanels/featured_video.module'
  //   )
  // );
  // //Featured_Video
  // //Giving_History
  // const Giving_History = React.lazy(() =>
  //   import(
  //     '../../../../apps/tenant' +
  //       props.tenantId +
  //       '/src/modules/' +
  //       brand +
  //       '/pallete2022/ContentPanels/giving_history.module'
  //   )
  // );
  // //Giving_History
  // //Link
  // const Link = React.lazy(() =>
  //   import(
  //     '../../../../apps/tenant' +
  //       props.tenantId +
  //       '/src/modules/' +
  //       brand +
  //       '/pallete2022/ContentPanels/link.module'
  //   )
  // );
  // //Link
  // //Download
  // const Download = React.lazy(() =>
  //   import(
  //     '../../../../apps/tenant' +
  //       props.tenantId +
  //       '/src/modules/' +
  //       brand +
  //       '/pallete2022/ContentPanels/download.module'
  //   )
  // );
  // //Download
  // //Contact
  // const ContactPanel = React.lazy(() =>
  //   import(
  //     '../../../../apps/tenant' +
  //       props.tenantId +
  //       '/src/modules/' +
  //       brand +
  //       '/pallete2022/ContentPanels/contact_panel.module'
  //   )
  // );
  // //Contact
  // //Documents
  // const Documents = React.lazy(() =>
  //   import(
  //     '../../../../apps/tenant' +
  //       props.tenantId +
  //       '/src/modules/' +
  //       brand +
  //       '/pallete2022/ContentPanels/documents.module'
  //   )
  // );
  // //Documents
  // //Documents_Small
  // const Documents_Small = React.lazy(() =>
  //   import(
  //     '../../../../apps/tenant' +
  //       props.tenantId +
  //       '/src/modules/' +
  //       brand +
  //       '/pallete2022/ContentPanels/documents_small.module'
  //   )
  // );
  // //Documents_Small
  // //Endorsement
  // const Endorsement = React.lazy(() =>
  //   import(
  //     '../../../../apps/tenant' +
  //       props.tenantId +
  //       '/src/modules/' +
  //       brand +
  //       '/pallete2022/ContentPanels/endorsement.module'
  //   )
  // );
  // //Endorsement
  // //Footnote
  // const Footnote = React.lazy(() =>
  //   import(
  //     '../../../../apps/tenant' +
  //       props.tenantId +
  //       '/src/modules/' +
  //       brand +
  //       '/pallete2022/ContentPanels/footnote.module'
  //   )
  // );
  // //Footnote
  // //Featured_News
  // const Featured_News = React.lazy(() =>
  //   import(
  //     '../../../../apps/tenant' +
  //       props.tenantId +
  //       '/src/modules/' +
  //       brand +
  //       '/pallete2022/ContentPanels/featured_news.module'
  //   )
  // );
  // //Featured_News

  // // Gallery
  //  const Gallery = React.lazy(() =>
  //    import(
  //      '../../../../apps/tenant' +
  //        props.tenantId +
  //        '/src/modules/' +
  //        brand +
  //       '/pallete2022/ContentPanels/gallery.module'
  //   )
  //  );
  // //Gallery
  // // Caption_Gallery
  //  const Caption_Gallery = React.lazy(() =>
  //    import(
  //      '../../../../apps/tenant' +
  //        props.tenantId +
  //        '/src/modules/' +
  //        brand +
  //        '/pallete2022/ContentPanels/caption_gallery.module'
  //    )
  //  );
  //Caption_Gallery

  // End  System Panel

  var allRoutes = [{
    path: '/error',
    name: 'error',
    component: Error,
    route: _reactRouterDom.Route
  }, {
    path: '/passcode',
    name: 'passcode',
    component: Passcode,
    route: _reactRouterDom.Route
  }, {
    path: '/site',
    name: 'site',
    component: Site,
    route: _reactRouterDom.Route
  }, {
    path: '/site/edit',
    name: 'site',
    component: Site,
    route: _reactRouterDom.Route
  }, {
    path: '/report',
    name: 'report',
    component: Report,
    route: _reactRouterDom.Route
  }, {
    path: '/report/edit',
    name: 'report',
    component: Report,
    route: _reactRouterDom.Route
  }, {
    path: '/login',
    name: 'commonLogin',
    component: CommonLogin,
    route: _reactRouterDom.Route
  }, {
    path: '/contact',
    name: 'contact',
    component: Contact,
    route: _reactRouterDom.Route
  }, {
    path: '/contact/edit',
    name: 'contact',
    component: Contact,
    route: _reactRouterDom.Route
  },
  // Start  System Panel
  //Invite
  {
    path: '/invite',
    name: 'invite',
    component: Invite,
    route: _reactRouterDom.Route
  }, {
    path: '/invite/edit',
    name: 'invite',
    component: Invite,
    route: _reactRouterDom.Route
  },
  //Invite
  //Profile
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    route: _reactRouterDom.Route
  }, {
    path: '/profile/edit',
    name: 'profile',
    component: Profile,
    route: _reactRouterDom.Route
  },
  //Profile
  //Featured Video
  {
    path: '/featured_video',
    name: 'featured_video',
    component: FeaturedVideo,
    route: _reactRouterDom.Route
  }, {
    path: '/featured_video/edit',
    name: 'featured_video',
    component: FeaturedVideo,
    route: _reactRouterDom.Route
  },
  //Featured Video
  //Giving_History
  {
    path: '/giving_history',
    name: 'giving_history',
    component: Giving_History,
    route: _reactRouterDom.Route
  }, {
    path: '/giving_history/edit',
    name: 'giving_history',
    component: Giving_History,
    route: _reactRouterDom.Route
  },
  //Giving_History
  //Link
  {
    path: '/link',
    name: 'link',
    component: Link,
    route: _reactRouterDom.Route
  }, {
    path: '/link/edit',
    name: 'link',
    component: Link,
    route: _reactRouterDom.Route
  },
  //Link
  //Downlaod
  {
    path: '/download',
    name: 'download',
    component: Download,
    route: _reactRouterDom.Route
  }, {
    path: '/download/edit',
    name: 'download',
    component: Download,
    route: _reactRouterDom.Route
  },
  //Downlaod

  //Contact
  {
    path: '/contact_panel',
    name: 'contact_panel',
    component: ContactPanel,
    route: _reactRouterDom.Route
  }, {
    path: '/contact_panel/edit',
    name: 'contact_panel',
    component: ContactPanel,
    route: _reactRouterDom.Route
  },
  //Contact
  //Documents
  {
    path: '/documents',
    name: 'documents',
    component: Documents,
    route: _reactRouterDom.Route
  }, {
    path: '/documents/edit',
    name: 'documents',
    component: Documents,
    route: _reactRouterDom.Route
  },
  //Documents
  //Documents_Small
  {
    path: '/documents_small',
    name: 'documents_small',
    component: Documents_Small,
    route: _reactRouterDom.Route
  }, {
    path: '/documents_small/edit',
    name: 'documents_small',
    component: Documents_Small,
    route: _reactRouterDom.Route
  },
  //Documents_Small
  //Endorsement
  {
    path: '/endorsement',
    name: 'endorsement',
    component: Endorsement,
    route: _reactRouterDom.Route
  }, {
    path: '/endorsement/edit',
    name: 'endorsement',
    component: Endorsement,
    route: _reactRouterDom.Route
  },
  //Endorsement
  //Footnote
  {
    path: '/footnote',
    name: 'footnote',
    component: Footnote,
    route: _reactRouterDom.Route
  }, {
    path: '/footnote/edit',
    name: 'footnote',
    component: Footnote,
    route: _reactRouterDom.Route
  },
  //Footnote
  //Featured_News
  {
    path: '/featured_news',
    name: 'featured_news',
    component: Featured_News,
    route: _reactRouterDom.Route
  }, {
    path: '/featured_news/edit',
    name: 'featured_news',
    component: Featured_News,
    route: _reactRouterDom.Route
  },
  //Featured_News

  // Gallery
  {
    path: '/gallery',
    name: 'gallery',
    component: Gallery,
    route: _reactRouterDom.Route
  }, {
    path: '/gallery/edit',
    name: 'gallery',
    component: Gallery,
    route: _reactRouterDom.Route
  },
  // Gallery
  //Caption_Gallery
  {
    path: '/caption_gallery',
    name: 'caption_gallery',
    component: Caption_Gallery,
    route: _reactRouterDom.Route
  }, {
    path: '/caption_gallery/edit',
    name: 'caption_gallery',
    component: Caption_Gallery,
    route: _reactRouterDom.Route
  }
  // Caption_Gallery
  // End Invite System Panel
  ];
  return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement("div", null, "Loading...")
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: allRoutes.map(function (r) {
      return r['path'];
    })
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, allRoutes.map(function (route, index) {
    return !route.children && /*#__PURE__*/_react.default.createElement(route.route, {
      key: index,
      path: route.path,
      roles: route.roles,
      exact: route.exact,
      component: route.component
    });
  }))), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    to: "/login"
  })))));
}
var _default = RouteShared;
exports.default = _default;